/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../../shared/services/util.service';
import { NotificationComponent } from '../../../shared/components/notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, FormControl, ReactiveFormsModule, Validators, type FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StartStopMoveService } from '../../../shared/services/start-stop-move.service';
import { debounceTime, distinctUntilChanged, map, type Observable } from 'rxjs';
import { type AGLResponse } from '../../../shared/models/agl-address-response';
import { AsyncPipe, isPlatformBrowser } from '@angular/common';
import { MatAutocompleteModule, type MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ServiceAddress } from '../../../shared/models/service-address';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { postalCodeValidator } from '../../../shared/validators/postalCode.validator';
import { UserProfile } from '../../../shared/models/user-profile';
import { type Address } from '../../../shared/models/address';
import { StorageEnum } from '../../../shared/enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../../shared/services/storage.service';
import { States } from '../../../shared/enums/states.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MailingAddressService } from '../../../shared/services/mailing-address.service';
import { AccountDetail } from '../../../shared/models/account-detail';
import { MailingAddressComponent } from '../../../shared/components/mailing-address/mailing-address.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../../shared/services/cms.service';
import { SsmStepperComponent } from '../../../shared/components/ssm-stepper/ssm-stepper.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../../shared/services/notifications.service';
import { NotificationType } from '../../../shared/enums/notificationtype.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';
import { SSMProcessData, StartServiceRequest } from '../../../shared/models/start-service';
import { PageHeader } from '../../../shared/models/page-header.model';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';
import { SsmSidePanelComponent } from '../../../shared/components/ssm-side-panel/ssm-side-panel.component';
import { MatDividerModule } from '@angular/material/divider';
import { Nav } from '../../../shared/enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../../shared/services/seo.service';
import { emailValidator } from '../../../shared/validators/email.validator';
import { EmailInfo } from '../../../shared/models/email-info';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../../shared/services/account.service';
import { EmailFormComponent } from '../../../shared/components/email-form/email-form.component';

@Component({
  selector: 'app-start-service',
  imports: [
    NotificationComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    AsyncPipe,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    MailingAddressComponent,
    SsmStepperComponent,
    PageHeaderComponent,
    SsmSidePanelComponent,
    MatDividerModule,
    EmailFormComponent,
    RouterModule,
  ],
  templateUrl: './start-service.component.html',
  styleUrl: './start-service.component.scss',
})
export class StartServiceComponent implements OnInit {
  pageReady = false;
  formErrorMessage: string = '';
  zipLookUpForm: FormGroup;
  addressesByCurrentZip: AGLResponse[] = [];
  serviceAddressForm: FormGroup;
  addressFilteredByCustomerTyping: Observable<AGLResponse[]> | undefined;
  startServiceAddress: ServiceAddress = new ServiceAddress();
  userSelectedAddressFromAutoComplete = false;
  partialMatches: any;
  manuallyEnteredAddress: ServiceAddress = new ServiceAddress();
  partialMatchForm: FormGroup;
  showPartialMatchesForm = false;
  useServiceAddressAsMailingAddress = true;
  mailingAddressFormData: any = {};
  isBrowser = false;
  loginRes: UserProfile = new UserProfile();
  isMultiAccount: boolean = false;
  addressList: Address[] = [];
  userVerifiedAddress: boolean = false;
  unverifiedAddress: boolean = false;
  unverifiedAddressChanged: boolean = false;
  accountDetail: AccountDetail = new AccountDetail();
  standarFormErrorMessage = '';
  showServiceAddressForm = false;
  pageLabels: any;
  process = 'start';
  step = 1;
  pageName = 'start-service-address-form';
  ssmRequest: StartServiceRequest = new StartServiceRequest();
  ssmProcessData: SSMProcessData = new SSMProcessData();
  customerReturning = false;
  pageHeader = new PageHeader();
  hasEmail = false;
  emailFormData: any = {};

  constructor(
    private readonly utils: UtilService,
    private readonly fb: FormBuilder,
    private readonly ssmService: StartStopMoveService,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly storage: StorageService,
    private readonly mailingAddressService: MailingAddressService,
    private readonly cms: CmsService,
    private readonly notifi: NotificationsService,
    private readonly router: Router,
    private readonly seoS: SeoService,
    private readonly account: AccountService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.loginRes = this.storage.getSession(StorageEnum.LoginResponse);
      this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
      this.standarFormErrorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
    }
    this.zipLookUpForm = this.fb.group({
      ZipCode: ['', [Validators.required, postalCodeValidator()]],
    });
    this.serviceAddressForm = this.fb.group({
      AddressLineOne: ['', [Validators.required]],
      City: ['', [Validators.required]],
      State: 'GA',
      UseAsMailingAddress: true,
    });
    this.partialMatchForm = this.fb.group({
      Address: new FormControl(),
    });
    this.partialMatchForm.get('Address')?.setValidators([Validators.required]);
    if (!this.utils.isNullOrUndefined(this.storage.getSession(StorageEnum.SSMData))) {
      this.ssmProcessData = this.storage.getSession(StorageEnum.SSMData);
      if (!this.utils.isNullOrUndefined(this.ssmProcessData.CurrentProcess)) {
        if (this.ssmProcessData.CurrentProcess === 'move') {
          this.process = 'move';
          this.step = 2;
        }
        if (this.ssmProcessData.CurrentProcess === 'start') {
          this.customerReturning = true;
        }
      }
    }
  }

  ngOnInit(): void {
    this.cms.getContent('oas-start-service-address-lookup-labels', 'Start Service').subscribe((data: any) => {
      this.pageLabels = data;
      this.pageHeader.Message =
        this.ssmProcessData.CurrentProcess === 'move' ? this.pageLabels.movePageHeader : this.pageLabels.pageHeader;
      this.seoS.setSeoTags(data.seo);
      this.utils.hideSpinner();
      this.addressFilteredByCustomerTyping = this.serviceAddressForm.get('AddressLineOne')?.valueChanges.pipe(
        // startWith(''),
        debounceTime(200),
        distinctUntilChanged(),
        map((value) => this.filterAddressAsUserTypes(value)),
      );
      this.setupMailingAddressData();
      if (this.customerReturning) {
        this.preloadFormWithExistingDate();
      }
      this.hasEmail =
        this.accountDetail?.Person?.EmailAddresses?.find((email: EmailInfo) => {
          return email.IsPrimary && email.Type?.toUpperCase() === 'EMAIL';
        })?.IsPrimary ?? false;
      if (!this.hasEmail) {
        this.setupEmailData();
      }
      this.pageReady = true;
    });

    this.partialMatchForm.valueChanges.subscribe((data: any) => {
      // update service address form with information dropdown
      this.serviceAddressForm.get('AddressLineOne')?.setValue(data.Address.Address1);
      this.serviceAddressForm.get('City')?.setValue(data.Address.City);
      if (data.Address.PostalCode !== undefined) {
        this.zipLookUpForm.get('ZipCode')?.setValue(data.Address.PostalCode);
      } else {
        this.zipLookUpForm.get('ZipCode')?.setValue(data.Address.ZipCode);
      }
    });
  }

  lookUpAddressesByZip(): void {
    this.utils.showSpinner();
    this.notifi.clearAllNotifications();
    if (this.showPartialMatchesForm) {
      this.partialMatchForm.reset();
      this.showPartialMatchesForm = false;
    }
    if (this.showServiceAddressForm) {
      this.showServiceAddressForm = false;
      this.serviceAddressForm.reset();
      this.serviceAddressForm.get('UseAsMailingAddress')?.setValue(true);
      this.serviceAddressForm.get('State')?.setValue('GA');
    }
    if (this.zipLookUpForm.valid) {
      const zip = this.zipLookUpForm.get('ZipCode')?.value;
      this.ssmService.getAddressByZip(zip).subscribe({
        error: (e) => {
          this.notifi.addNotification(this.pageLabels.zipLookUpError, NotificationType.Alert, this.pageName);
        },
        next: (data: AGLResponse[]) => {
          if (data.length && data.length > 0) {
            this.addressesByCurrentZip = data;
            this.showServiceAddressForm = true;
          } else {
            this.notifi.addNotification(this.pageLabels.zipNotServicedError, NotificationType.Alert, this.pageName);
          }

          this.utils.hideSpinner();
        },
      });
    } else {
      this.zipLookUpForm.markAllAsTouched();
      this.notifi.addNotification(this.standarFormErrorMessage, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
    }
  }

  filterAddressAsUserTypes(val: string): AGLResponse[] {
    if (typeof val !== 'string') {
      return this.addressesByCurrentZip;
    }
    const filteredValue = val.toLowerCase();
    return this.addressesByCurrentZip.filter((addr) => addr.FullAddress.toLowerCase().startsWith(filteredValue));
  }

  addressSelectedFromDropdown(event: MatAutocompleteSelectedEvent): void {
    const address = event.option.value;
    const lineOneValue =
      address.StreetAddressCombinedWithLot !== ''
        ? address.StreetAddressCombinedWithLot
        : address.StreetAddressCombined;
    this.serviceAddressForm.get('AddressLineOne')?.setValue(lineOneValue);
    this.serviceAddressForm.get('City')?.setValue(address.ServiceAddressCity);
    this.startServiceAddress.Address1 = lineOneValue;
    this.startServiceAddress.City = address.ServiceAddressCity;
    this.startServiceAddress.PostalCode = address.ServiceAddressZipCode;
    this.startServiceAddress.State = 'GA';
    this.startServiceAddress.FullAddress = address.FullAddress;
    this.startServiceAddress.PremiseId = address.AGLCPremisesNumber;
    this.userSelectedAddressFromAutoComplete = true;
  }

  handleSubmit(): void {
    this.utils.showSpinner();
    if (!this.hasEmail) {
      // handle new email stuff
      if (this.emailFormData.formGroup.valid) {
        const emailValue = this.emailFormData.formGroup.value.email;

        const personRequest = this.accountDetail?.Person;
        const email = new EmailInfo();
        email.ContactId = '';
        email.Email = emailValue;
        email.IsActive = true;
        email.IsPrimary = true;
        email.Type = 'EMAIL';
        personRequest?.EmailAddresses?.push(email);
        this.account.UpdatePersonContact(personRequest).subscribe({
          error: (e) => {
            this.utils.consoleLog('There was an error adding email on stop service page. Error: ' + e);
            this.utils.hideSpinner();
          },
          next: (data: any) => {
            this.accountDetail.Person = data;
            this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
            this.hasEmail = true;
            this.handleAddressSelection();
          },
        });
      } else {
        this.emailFormData.formGroup.markAllAsTouched();
        this.notifi.addNotification(this.standarFormErrorMessage, NotificationType.Alert, this.pageName);
        this.utils.hideSpinner();
      }
    } else {
      this.handleAddressSelection();
    }
  }

  handleAddressSelection(): void {
    if (this.userSelectedAddressFromAutoComplete) {
      if (this.useServiceAddressAsMailingAddress) {
        this.goToNextStep();
      } else {
        this.updateMailingAddress();
      }
    } else {
      if (!this.serviceAddressForm.valid) {
        this.serviceAddressForm.markAllAsTouched();
        this.notifi.addNotification(this.standarFormErrorMessage, NotificationType.Alert, this.pageName);
        this.utils.hideSpinner();
      } else {
        if (this.showPartialMatchesForm) {
          if (!this.partialMatchForm.valid) {
            this.partialMatchForm.markAllAsTouched();
            this.notifi.addNotification(this.standarFormErrorMessage, NotificationType.Alert, this.pageName);
            this.utils.hideSpinner();
          } else {
            if (this.partialMatchForm.get('Address')?.value === this.manuallyEnteredAddress) {
              this.startServiceAddress = this.manuallyEnteredAddress;
            } else {
              const addr = this.partialMatchForm.get('Address')?.value;
              this.startServiceAddress.Address1 =
                addr.Address2 === '' ? addr.Address1 : addr.Address1 + ' ' + addr.Address2;
              this.startServiceAddress.FullAddress = addr.FullStreetAddress;
              this.startServiceAddress.City = addr.City;
              this.startServiceAddress.State = 'GA';
              this.startServiceAddress.PostalCode = addr.ZipCode;
              this.startServiceAddress.PremiseId = addr.AGLCPremisesNumber;
            }
            this.ssmProcessData.StartServiceAddress = this.startServiceAddress;
            if (this.useServiceAddressAsMailingAddress) {
              this.goToNextStep();
            } else {
              this.updateMailingAddress();
            }
          }
        } else {
          this.showPartialMatchesForm = true;
          const data = new ServiceAddress();
          data.Address1 = this.serviceAddressForm.get('AddressLineOne')?.value;
          data.City = this.serviceAddressForm.get('City')?.value;
          data.PostalCode = this.zipLookUpForm.get('ZipCode')?.value;
          this.manuallyEnteredAddress = data;
          this.ssmService.getAGLAddressList(data).subscribe({
            error: (e) => {
              this.utils.hideSpinner();
              // route to error i guess
            },
            next: (data: any) => {
              this.partialMatches = data;
              this.utils.hideSpinner();
            },
          });
        }
      }
    }
  }

  toggleMailingAddress(): void {
    this.useServiceAddressAsMailingAddress = !this.useServiceAddressAsMailingAddress;
  }

  setupMailingAddressData(): void {
    if (this.loginRes.TotalNumAccounts && this.loginRes.TotalNumAccounts > 1) {
      this.isMultiAccount = true;
    }
    this.mailingAddressFormData.isMultiAccount = this.isMultiAccount;
    this.mailingAddressFormData.formGroup = this.fb.group({
      address1: ['', [Validators.required]],
      address2: [''],
      city: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalCodeValidator()]],
      state: [States.GA],
      setDefault: [false],
      addressRadioGroup: [''],
    });

    this.mailingAddressFormData.addressList = this.addressList;
  }

  updateMailingAddress(): void {
    if (this.mailingAddressFormData.formGroup.valid) {
      if (
        (!this.mailingAddressFormData.formGroup.get('addressRadioGroup').value && !this.unverifiedAddress) ||
        this.unverifiedAddressChanged
      ) {
        this.verifyMailingAddress();
      } else {
        this.mailingAddressService
          .updateMailingAddress(this.mailingAddressFormData.formGroup, this.accountDetail, this.isMultiAccount)
          .subscribe({
            error: (e) => {
              const errorMessage = this.pageLabels.mailingAddressServiceError;
              this.mailingAddressFormData.formGroup.markAllAsTouched();
              this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
              this.utils.hideSpinner();
            },
            next: () => {
              this.ssmProcessData.UseNewMailingAddressOnAllAccounts =
                this.mailingAddressFormData.formGroup.get('setDefault').value;
              this.goToNextStep();
            },
          });
      }
    } else {
      // Mark all controls as touched to trigger validation messages
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.mailingAddressFormData.formGroup.markAllAsTouched();
      this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
    }
  }

  verifyMailingAddress(): void {
    this.unverifiedAddressChanged = false;
    this.mailingAddressService.mailingAddressVerification(this.mailingAddressFormData.formGroup).subscribe({
      error: (e) => {
        this.addressList.length = 0;
        this.unverifiedAddress = true;
        this.utils.hideSpinner();
      },
      next: (data: any) => {
        if (data) {
          this.addressList.pop();
          this.addressList.pop();
          this.addressList.push(data[0]);
          this.addressList.push(data[1]);
          this.mailingAddressFormData.addressList = this.addressList;
          this.mailingAddressFormData.formGroup.get('addressRadioGroup').setValue(this.addressList[0]);
          this.mailingAddressFormData.formGroup.get('address1')?.setValue(data[0].Address1);
          this.mailingAddressFormData.formGroup.get('address2')?.setValue(data[0].Address2);
          this.mailingAddressFormData.formGroup.get('city')?.setValue(data[0].City);
          this.mailingAddressFormData.formGroup.get('postalCode')?.setValue(data[0].PostalCode);
          this.mailingAddressFormData.formGroup.get('state')?.setValue(data[0].State);
          this.utils.hideSpinner();
        }
      },
    });
  }

  unverifiedAddressData(data: boolean): void {
    this.unverifiedAddressChanged = data;
  }

  goToNextStep(): void {
    // route to next step eventually
    this.utils.hideSpinner();
    // map all relevant address data to start/move/reconnect request object
    this.ssmRequest.Address1 = this.startServiceAddress.Address1;
    this.ssmRequest.City = this.startServiceAddress.City;
    this.ssmRequest.State = this.startServiceAddress.State;
    this.ssmRequest.ZipCode = this.startServiceAddress.PostalCode;
    this.ssmRequest.AGLPremiseId = this.startServiceAddress.PremiseId;

    this.ssmProcessData.StartServiceAddress = this.startServiceAddress;

    this.ssmProcessData.StartRequest = this.ssmRequest;

    if (this.useServiceAddressAsMailingAddress) {
      this.ssmProcessData.UseServiceAddressAsMailingAddress = true;
    } else {
      this.ssmProcessData.UseServiceAddressAsMailingAddress = false;
      this.ssmProcessData.MailingAddress = this.accountDetail.Person?.BillingAddress;
    }
    if (this.utils.isNullOrUndefined(this.ssmProcessData.CurrentProcess)) {
      this.ssmProcessData.CurrentProcess = 'start';
    }
    this.storage.setSession(StorageEnum.SSMData, this.ssmProcessData);
    if (this.ssmProcessData.CurrentProcess === 'start') {
      void this.router.navigateByUrl(Nav.StartServiceScheduleService);
    } else {
      void this.router.navigateByUrl(Nav.MoveServiceScheduleService);
    }
  }

  toggleHideAutoComplete(e: Event): void {
    const autocompletePane = document.getElementById('cdk-overlay-0');
    const val = (e.target as HTMLInputElement).value;
    if (val.length === 0) {
      autocompletePane?.classList.add('hide-autocomplete');
    } else {
      autocompletePane?.classList.remove('hide-autocomplete');
    }
  }

  preloadFormWithExistingDate(): void {
    this.zipLookUpForm.get('ZipCode')?.setValue(this.ssmProcessData.StartRequest?.ZipCode);
    this.serviceAddressForm.get('AddressLineOne')?.setValue(this.ssmProcessData.StartRequest?.Address1);
    this.serviceAddressForm.get('City')?.setValue(this.ssmProcessData.StartRequest?.City);
    this.serviceAddressForm.get('State')?.setValue(this.ssmProcessData.StartRequest?.State);
    this.showServiceAddressForm = true;
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = true;
    this.emailFormData.formGroup = this.fb.group({
      email: ['', [Validators.required, emailValidator()]],
      emailConfirm: ['', [Validators.required, emailValidator()]],
    });
  }

  goBack(): string {
    return Nav.MoveService;
  }
}
